import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentsService } from 'src/app/services/attachments.service';
import {
  ATTACHMENT_CATEGORIES,
  isAttachmentCategoryComplete
} from '../../../util/attachment-categories';

@Component({
  selector: 'app-edit-attachment-category',
  templateUrl: './edit-attachment-category.component.html',
  styleUrls: ['./edit-attachment-category.component.scss'],
  standalone: false
})
export class EditAttachmentCategoryComponent implements OnInit {
  @Input() attachmentId: number;
  @Input() filename = '';
  @Input() category = '';
  @Input() categoryother = '';
  @Output() categoryUpdated = new EventEmitter<boolean>();

  readonly categories = ATTACHMENT_CATEGORIES;
  selectedCategory = '';
  selectedCategoryOther = '';
  loading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    private attachmentsService: AttachmentsService
  ) {}

  ngOnInit() {
    this.selectedCategory = this.category || '';
    this.selectedCategoryOther = this.categoryother || '';
  }

  onCategoryChange() {
    if (this.selectedCategory !== 'otro') {
      this.selectedCategoryOther = '';
    }
  }

  get canSave(): boolean {
    return isAttachmentCategoryComplete({
      category: this.selectedCategory,
      categoryother: this.selectedCategoryOther
    });
  }

  save() {
    if (!this.canSave || this.loading) {
      this.errorMessage = 'Debe seleccionar una categoría válida.';
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.attachmentsService.updateCategory(
      this.attachmentId,
      this.selectedCategory,
      this.selectedCategory === 'otro' ? this.selectedCategoryOther.trim() : null
    ).subscribe({
      next: (resp: any) => {
        this.loading = false;
        if (resp?.error) {
          this.errorMessage = resp.error.message || 'No se pudo actualizar la categoría.';
          return;
        }
        this.successMessage = 'Categoría actualizada correctamente.';
        this.categoryUpdated.emit(true);
        setTimeout(() => this.activeModal.dismiss(), 800);
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = err?.error?.error?.message || err?.message || 'No se pudo actualizar la categoría.';
      }
    });
  }
}
